<template>
  <v-main>
    <v-card color="green lighten-5 fill-height">
      <v-card-title>
        <v-subheader>{{$t('rec_types.'+item.recType)}}</v-subheader>
        <v-subheader>{{$t('label.for')}}</v-subheader>
        <v-subheader>{{parentName}}</v-subheader>
        <v-spacer></v-spacer>
        <v-btn icon @click="close" color="error">
          <v-icon>mdi-close-circle</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-form ref="form" :lazy-validation="true">
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="item.name"
                :label="$t('field.name')+'*'"
                background-color="yellow lighten-5"
                color="black"
                :placeholder="$t('label.placeholder')"
                clearable
                shaped
                outlined
                :rules="[v => !!v || v!=null&&v.length<=64 || $t('error.lenght')]"
                counter="64"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row align="center">
            <v-col cols="6" class="mt-n9">
              <span class="mr-4">{{$t('field.valid')}}</span>
              <DatePicker
                format="YYYY-MM-DD"
                type="date"
                :placeholder="$t('label.placeholder')"
                v-model="item.validExt"
                :rules="validRules"
                :label="$t('field.valid')"
                input-class="idcs-data-pick"
                class="idcs-picker-wrap"
              ></DatePicker>
            </v-col>
            <v-col cols="3">
              <v-select
                :items="$t('recStatus')"
                :label="$t('field.status')"
                background-color="yellow lighten-5"
                color="black"
                :placeholder="$t('label.placeholder')"
                shaped
                outlined
                v-model="item.status"
              ></v-select>
            </v-col>
            <v-col cols="3">
              <v-text-field
                v-model="item.operNr"
                background-color="yellow lighten-5"
                color="black"
                :placeholder="$t('label.placeholder')"
                shaped
                outlined
                :disabled="item.operNr==99999"
                type="number"
                :label="$t('field.operNr')"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col>
              <v-checkbox v-model="item.needPrint" :label="$t('field.needPrint')"></v-checkbox>
            </v-col>
            <v-col>
              <v-checkbox v-model="item.reversal" :label="$t('field.reversal')"></v-checkbox>
            </v-col>
            <v-col>
              <v-tooltip bottom>
                <template #activator="{ on, attrs }">
                  <div v-bind="attrs" v-on="on">
                    <v-checkbox v-model="item.needDisplay" :label="$t('field.needDisplay')"></v-checkbox>
                  </div>
                </template>
                <i18n path="tooltip.needDisplay" />
              </v-tooltip>
            </v-col>
            <v-col>
              <v-tooltip bottom>
                <template #activator="{ on, attrs }">
                  <div v-bind="attrs" v-on="on">
                    <i18n path="field.par1" />
                    <v-switch v-model="mobileParam" class="d-inline-flex ml-2"></v-switch>
                    <i18n path="field.par2" />
                  </div>
                </template>
                <i18n path="tooltip.mobileParam" />
              </v-tooltip>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-textarea
                v-model="item.formula"
                :placeholder="$t('label.placeholder')"
                background-color="yellow lighten-5"
                color="black"
                shaped
                outlined
                no-resize
                id="formula-text"
                append-outer-icon="fa-expand-alt"
                @click:append-outer="d_edit=true"
                :rules="[v => v==null || v!=null&&v.length<=4000 || $t('error.lenght')]"
                counter="4000"
                :label="$t('field.formula')"
              ></v-textarea>
            </v-col>
            <v-col cols="12">
              <v-textarea
                v-model="item.initFormula"
                background-color="yellow lighten-5"
                color="black"
                :placeholder="$t('label.placeholder')"
                shaped
                auto-grow
                outlined
                :rules="[v => v==null || v!=null&&v.length<=1024 || $t('error.lenght')]"
                counter="1024"
                :label="$t('field.initFormula')"
              ></v-textarea>
            </v-col>
            <v-col cols="6">
              {{$t('field.created')+':'}}
              <small>{{item.created}}</small>
            </v-col>
            <v-col cols="6" class="last-modified">
              {{$t('field.modified')+':'}}
              <small>{{item.lastModified}}</small>
            </v-col>
            <v-col cols="12">
              <v-alert
                v-model="showAlert"
                border="left"
                colored-border
                type="error"
                elevation="2"
                :dismissible="true"
                transition="fade-transition"
              >{{alertMessage}}</v-alert>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-btn
          v-if="$store.getters.test('SystemDetailRecord.d')"
          color="blue darken-1"
          text
          @click="simpleDialog=true"
        >{{$t('button.delete')}}</v-btn>
        <v-spacer></v-spacer>
        <v-btn
          v-if="$store.getters.test('SystemDetailRecord.w')"
          color="blue darken-1"
          text
          @click="save(false)"
        >{{$t('button.apply')}}</v-btn>
        <v-btn
          v-if="$store.getters.test('SystemDetailRecord.w')"
          color="blue darken-1"
          text
          @click="save(true)"
        >{{$t('button.save')}}</v-btn>
      </v-card-actions>
    </v-card>
    <v-dialog v-model="d_edit" fullscreen>
      <v-card class="yellow lighten-5">
        <v-card-title>
          <span>{{$t('field.formula')}}</span>
          <v-spacer></v-spacer>
          <v-btn icon color="error" @click="d_edit=false">
            <v-icon>mdi-close-circle</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-textarea
            v-model="item.formula"
            background-color="yellow lighten-5"
            color="black"
            full-width
            rows="32"
            :placeholder="$t('label.placeholder')"
            :rules="[v => v==null || v!=null&&v.length<=4000 || $t('error.lenght')]"
            counter="4000"
          ></v-textarea>
        </v-card-text>
      </v-card>
    </v-dialog>
    <DeleteDialog v-model="simpleDialog" @click:ok="erase" />
  </v-main>
</template>
<script>
//import axios from "axios";
import app from "@/app.js";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import DeleteDialog from "@/components/DeleteDialog.vue";

export default {
  components: { DatePicker, DeleteDialog },
  name: "SystemDetailEditor",
  props: {
    record: { type: Object, required: true },
    isnew: { type: Boolean },
    value: { type: Boolean },
  },
  data() {
    return {
      d_edit: false,
      simpleDialog: false,
      showAlert: false,
      alertMessage: "",
      userRules: [(v) => !!v || this.$t("error.required")],
      validRules: [
        (v) => (!!v && this.$moment(v).afterNow()) || this.$t("error.valid"),
      ],
      formulaRules: [
        (v) => (v && v.length < 4000) || this.$t("error.required"),
      ],
      item: this.record,
    };
  },
  watch: {
    record: {
      handler() {
        this.item = Object.assign({}, this.record);
        this.setDefaults();
      },
      deep: true,
    },
  },
  computed: {
    parentName() {
      try {
        return this.$store.getters["struct/systemById"](this.item.fk).text;
      } catch (error) {
        return this.item.fk;
      }
    },
    mobileParam: {
      get() {
        try {
          return app.getRule(this.item.sysData, "mp", "1") == "2";
        } catch (error) {
          return 1;
        }
      },
      set(v) {
        this.item.sysData = app.setRule(this.item.sysData, "mp", v ? "2" : "1");
      },
    },
  },
  mounted() {
    this.setDefaults();
  },
  methods: {
    setDefaults() {
      if (!this.item.operNr) this.item.operNr = 0;
      if (!this.item.formula)
        this.item.formula =
          "/* Operation Nr." +
          this.item.operNr +
          " . Created " +
          this.$moment().format("lll") +
          " */";
      if (!this.item.validExt)
        this.item.validExt = this.$moment().add("year", 10).toDate();
    },
    close() {
      this.$emit("input", false);
    },
    erase() {
      this.simpleDialog = false;
      app
        .erase(this.item.id, this.item.recType)
        .then(() => {
          this.$emit("delete", this.item);
          this.close();
        })
        .catch((error) => {
          this.showAlertMessage(error);
        });
    },
    save(close) {
      if (!this.$refs.form.validate()) return;
      //      console.log(this.isnew, this.item.fk_, this.item.fk)
      let newRec = this.isnew;
      if (this.item.fk_ == "dummy") newRec = false;
      let params = {
        status: this.item.status,
        name: this.item.name,
        formula: this.item.formula,
        operNr: this.item.operNr ? this.item.operNr : 0,
        initFormula: this.item.initFormula,
        sysData: this.item.sysData,
        validExt: this.$moment(this.item.validExt).format("YYYY-MM-DD"),
      };
      if (newRec) params.fk = this.record.fk;
      if (this.item.needPrint) params.needPrint = this.item.needPrint;
      if (this.item.needDisplay) params.needDisplay = this.item.needDisplay;
      if (this.item.reversal) params.reversal = this.item.reversal;
      app
        .update(this.item.id, this.item.recType, params)
        .then(() => {
          if (newRec) {
            this.$emit("insert", this.item);
            this.item.fk_ = "dummy";
          } else {
            this.$emit("update", this.item);
          }
          if (close) this.close();
        })
        .catch((error) => {
          this.showAlertMessage(error);
        });
    },
    showAlertMessage(m) {
      if (m.errorMsg) {
        this.alertMessage = this.$t("error." + m.errorMsg);
      } else {
        this.alertMessage = JSON.stringify(m);
      }
      this.showAlert = true;
      setTimeout(() => {
        this.showAlert = false;
      }, 4000);
    },
  },
};
</script>

<style scoped>
.last-modified {
  text-align: right;
}
#formula-text {
  overflow: hidden;
}
</style>